import { useEffect } from 'react';

export function useClickOutside(ref, onClick, exceptSelectors = []) {
  useEffect(() => {
    function handleClickOutside(event) {
      const [mouseTarget] = event.path ? event.path : [event.target];

      const canClose = !exceptSelectors.some(selector => mouseTarget.closest(selector));

      if (ref.current && !ref.current.contains(mouseTarget) && canClose) {
        onClick(event);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClick, exceptSelectors]);
}